import React, { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'

import { tokens } from 'styling/tokens'
import { useDispatch, useSelector } from 'react-redux'
import { clearIssuesList, deleteIssue, getIssues } from 'features/issues/issuesSlice'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { ITableItem, ModalTypes } from 'types/global.interface'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'
import { HonestTable, IHonestTableColumn, IHonestTableMenuOption } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'

export const Issues = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { issues, totalPages } = useSelector((store: RootState) => store.issues)
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location }))

  useQueryPagination({ fetchFunctions: [getIssues], cleanUpFunctions: [clearIssuesList], params })

  const removeRole = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteIssue(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: issues.length < 2,
        },
        word: 'delete issue',
      }),
    )
  }

  const columns: IHonestTableColumn<any>[] = [
    {
      id: 'name',
      header: 'Name',
      cell: (item) => item.name,
    },
  ]

  const menuOptions: IHonestTableMenuOption<any>[] = [
    { label: 'Edit', onClick: (item) => navigate(item.id + '/edit') },
    { label: 'Delete', color: tokens.status.danger.fg, onClick: (item) => removeRole(item.id) },
  ]

  const filters = [
    {
      type: FilterEnum.SEARCH,
      link: LinkEnum.INDUSTRIES,
      name: 'Industries',
      state: null,
    },
  ]

  return (
    <>
      <NavBar defaultValue={params.q} placeholder='Search Issues...' input setParams={setParams} params={params} filterOptions={filters} />
      <PageWrapper>
        <Flex center between mb='16' >
          <H1WithBack title='Issues' arrow />
          <Button variant='primary' onClick={() => navigate('add')}>
            Add Issue
          </Button>
        </Flex>

        {issues?.length ? (
          <HonestTable
            columns={columns}
            data={issues as ITableItem[]}
            keyField='id'
            onClick={(item) => navigate(item.id + '/edit')}
            menuOptions={menuOptions}
          />
        ) : (
          <NoData />
        )}
        <PageFooter>
          <Pagination
            setPage={(page) => handlePagination(page, setParams)}
            pageCount={Math.ceil(totalPages)}
            forcePage={(params.page ? params.page : 1) - 1}
          />
        </PageFooter>
      </PageWrapper>
    </>
  )
}
